<script setup lang="ts">
import { onMounted } from 'vue';
import ModalContent from '@zyro-inc/site-modules/components/ecommerce/modals/partials/ModalContent.vue';
import ModalLayout from '@zyro-inc/site-modules/components/ecommerce/modals/partials/ModalLayout.vue';
import { useEcommerceModal } from '@zyro-inc/site-modules/components/ecommerce/modals/useEcommerceModal';
import EventLogApi from '@zyro-inc/site-modules/api/EventLogApi';

defineProps<{
	translations: Record<string, string>;
}>();

const { closeEcommerceModal } = useEcommerceModal();

onMounted(() => {
	EventLogApi.logEvent({
		eventName: 'builder_customers.ecomm.order_failed',
	});
});
</script>

<template>
	<ModalLayout ref="modal">
		<ModalContent
			qa-selector="failed"
			:title="translations.checkoutModalCantAcceptOrders"
			:text="translations.checkoutModalPleaseContact"
			:button-text="translations.close"
			@handle-close="closeEcommerceModal"
		/>
	</ModalLayout>
</template>
